module.exports = __webpack_public_path__ + "img/badge-list-thumb-125.664dd9b2.png";